import { render } from "./AssistanceView.vue?vue&type=template&id=48487258&scoped=true"
import script from "./AssistanceView.vue?vue&type=script&lang=js"
export * from "./AssistanceView.vue?vue&type=script&lang=js"

import "./AssistanceView.vue?vue&type=style&index=0&id=48487258&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48487258"]])

export default __exports__